import { useRef } from "react";
import { connect } from "react-redux";
import { Warning } from "../../../../components/button";
import Card from "../../../../components/card";
import Form from "./Form";
import { Container, Icon, Title } from "./style";

const Coupon = (props) => {
  const formRef = useRef();

  const { theme } = props;

  return (
    <>
      <Form refrence={formRef} />
      <Container className="mx-1">
        <Card className="py-3 px-2">
          <Icon className="fal fa-tags"></Icon>
          <Title className="mr-2" theme={theme}>
            کد تخفیف دارید ؟
          </Title>
          <Warning
            title="وارد کنید"
            containerClass="d-inline-block float-left"
            className="px-2-5 py-1"
            onClick={() => formRef.current.changeStatus()}
          />
        </Card>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Coupon);
